var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-memo-jumbotron",style:(("background-image: url(" + (_vm.data.bg) + ")"))},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.data.title)}}),_vm._v(" "),_vm._t("default",[(_vm.hasButton)?_c('b-button',{attrs:{"to":_vm.data.btnLink,"variant":"primary"}},[_vm._v("\n      "+_vm._s(_vm.data.btnText)+"\n    ")]):_vm._e()])],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45057119","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EJumbotron.vue
// module id = 866
// module chunks = 1